module.exports = __webpack_public_path__ + "img/restaurant_4.a05fe96a.jpg";